import React from "react";
import { Layout } from "antd";
import { useSelector } from "react-redux";
import { Header, Footer } from "../components";
import {
  SideMenu,
  Topics,
  SuggestedForums,
  ProfileIntro,
  UserActivity,
  AllForums,
  Categories,
} from "../components/Dashboard/Sidebar";

const { Content } = Layout;

const DashboardLayout = ({ children, rightHidden, page }) => {
  const { isSideBarCollapsed } = useSelector(({ common }) => common);
  return (
    <Layout>
      <Header loggedIn={true} />
      <div className="px-0 lg:px-12 py-0 lg:py-10 flex justify-between">
        <div className="hidden xl:block">
          <div
            className={
              page === "forums" || page === "Allforums" ? "block" : "hidden"
            }
          >
            <AllForums />
          </div>
          <div className={page === "users" ? "block" : "hidden"}>
            <UserActivity />
          </div>
          <div
            className={
              page === "livescores" || page === "standings" ? "block" : "hidden"
            }
          >
            <Categories />
          </div>
          <div className={page === "home" ? "block" : "hidden"}>
            <div className="hidden xl:block">
              <SideMenu />
            </div>
          </div>
        </div>
        <Content
          className={`w-full px-0 lg:px-10 overflow-hidden dashboard-content ${
            isSideBarCollapsed ? "hidden" : "block"
          }`}
        >
          {children}
        </Content>
        <div className="hidden xl:block">
          {!rightHidden ? (
            <div>
              <div className={page === "users" ? "hidden xl:block" : "hidden"}>
                <ProfileIntro />
              </div>
              <div className={page === "forums" ? "hidden xl:block" : "hidden"}>
                <Topics />
              </div>
              {/* <div className={page === "home" ? "hidden xl:block" : "hidden"}>
                <SuggestedFriends />
              </div> */}
              <div
                className={
                  page === "forums" ||
                  page === "home" ||
                  page === "livescores" ||
                  page === "standings" ||
                  page === "Allforums"
                    ? "hidden xl:block mt-0"
                    : "hidden"
                }
              >
                <SuggestedForums />
              </div>
              <div className={"block"}>
                <Footer />
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default DashboardLayout;
